import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { AppRouterService } from 'src/app/core/services/app-router.service';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { SessionService } from 'src/app/core/services/session.service';
import { Storage } from '@ionic/storage';
import { HelperService } from 'src/app/core/services/helper.service';
import { SearchService } from 'src/app/core/services/search.service';
import { AboutUsPage } from 'src/app/about-us/about-us.page';
import { MatDialog } from '@angular/material/dialog';
import { VendorBackendService } from 'src/app/core/services/vendor-services/vendor-backend.service';

@Component({
  selector: 'app-vendor-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class HeaderComponent implements OnInit {
  menuTrigger: any;

  formGroup = this.formBuilder.group({
    navhelp: '',
  });

  rememberMe: any;
  showguidenav: boolean;
  closebubblecross = false;
  settingNavItems = [
    {
      lableName: 'My Profile',
      icon: 'assets/images/profile.svg',
      url: '/vendor/baseapp/profile'
    },
    // {
    //   lableName: 'Change Password',
    //   icon: 'assets/images/chaange password.svg',
    //   // url: '/vendor/change-password'
    // },
    // {
    //   lableName: 'Change Password',
    //   icon: 'assets/images/chaange password.svg',
    //   // url: '/vendor/change-password-new'
    // },
    // {
    //   lableName: 'Multi-Factor Authentication',
    //   icon: 'assets/images/2 Factor Authentication.svg',
    //   // url: '/vendor/profile'
    // },
    // {
    //   lableName: 'Add Form',
    //   icon: 'assets/images/Add Form.svg',
    //   // url: ''
    // },
    // {
    //   lableName: 'Alert',
    //   icon: 'assets/images/Alert02.svg',
    //   // url: ''
    // },
    // {
    //   lableName: 'Activity Logs',
    //   icon: 'assets/images/active_log.svg',
    //   // url: '/vendor/activity-logs'
    // },
    // {
    //   lableName: 'Feedback',
    //   icon: 'assets/images/Feedback.svg',
    //   // url: ''
    // },
    // {
    //   lableName: 'Help',
    //   icon: 'assets/images/settings_help.svg',
    //   url: 'https://help.bizdata360.com/books/ezintegrations'
    // },
    // {
    //   lableName: 'About Us',
    //   icon: 'assets/images/about_us.svg',
    //   // url: '/vendor/about-us',
    //   action: () => this.openAboutUs()
    // },
    {
      lableName: 'Logout',
      icon: 'assets/images/Logout.svg',
      url: 'logout'
    }
  ];
  subscription: any;
  trailDaysLeft: any;
  freeTrialMode: boolean = false;
  roleid: any;

  categories: any[] = [];
  defaultCategory: any = '';
  routeId: any;
  cartCount: any;
  searchResult: any = '';

  constructor(
    private formBuilder: UntypedFormBuilder,
    private appRouter: AppRouterService,
    private sessionService: SessionService,
    private backendService: BackendService,
    private vendorBackendService: VendorBackendService,
    public storage: Storage,
    private searchService: SearchService,
    private helperservice: HelperService,
    private router: Router,
    private dialog: MatDialog
  ) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.searchResult = '';
      }
    });

    this.searchService.defaultCategorySubject.subscribe(value => {
      if (value) {
        this.defaultCategory = value;
      }
    });
  }

  ngOnInit() {
    this.getStorage().then((res) => {
      //console.log(res);
      this.trailDaysLeft = res.trailDaysLeft;
      this.freeTrialMode = res.freeTrialMode;
      this.roleid = res.roleid;
      if (res.showDialog == 1) {
        this.showguidenav = true;
      } else {
        this.showguidenav = false;
      }        
    });

    this.searchService.getCategoryResult().subscribe((data: any) => {
      this.categories = data;
      this.defaultCategory = data[0].name;
    });

    this.searchService.getRouteId().subscribe((data: any) => {
      this.routeId = data;
    });

    this.searchService.getCartCount().subscribe((data: any) => {
      this.cartCount = data !== undefined ? data : 0;
      // this.cartCount = data;
    });

  }


  handleClick(label: string, action: string) {
    if (label == "Logout") {
      this.logout();
    } else if (label == "My Profile") {
      this.appRouter.gotoPath(action);
    } else if (label == "Change Password") {
      this.appRouter.gotoPath(action);
    } else if (label == "Activity Logs"){
      this.appRouter.gotoPath(action);
    } else if (label == "Accounting and Billing") {
      this.appRouter.gotoPath(action);
    } else if (label == "Multi-Factor Authentication") {
      this.appRouter.gotoPath(action);
    } else if (label == "Help") {
      window.open("https://help.bizdata360.com/books/ezintegrations", '_blank');
    } else if (label == "About Us") {
      this.openAboutUs();
    } else if (label == "System Config"){
      this.appRouter.gotoPath(action);
    }
  }

  logout() {
    this.sessionService.clearStorage();
    this.appRouter.gotoPath('vendor/login');
  }

  searchStringMethod(searchResult): void {
    this.searchService.sendSearchResult(searchResult);
  }

  getSearchOnChange(e) {
    this.searchStringMethod(e);
  }

  clearSearch() {
    this.searchResult = "";
    this.searchStringMethod(this.searchResult);
  }

  isMarketplace(): boolean {
    const check = this.router.url.indexOf('/vendor/marketplace');

    if (check) {
      return false;
    }
    return true;
  }

  subscribeUser() {
    this.router.navigate(['/vendor/accounting-billing/plan'])
  }

  navhelp() {
    var val = this.formGroup.controls['navhelp'].value;
    if (val) {
      this.storage.set('showDialog', 1);
      this.helperservice.navhelpclear(false);
    } else {
      this.helperservice.navhelpclear(true);
      this.storage.set('showDialog', 0);
    }
    this.getStorage().then((res) => {
      let payload = {
        id: res.userId,
        show: val
      }
      this.vendorBackendService.PostAPICall('setPopUpFlag', payload, res.token)
        .subscribe(
          data => {
            if (data) {
              if (val) {
                this.helperservice.presentToast("Navigation Help Enabled", 2000);
              } else {
                this.helperservice.presentToast("Navigation Help Disabled", 2000);
              }
            }
          },
          (error) => {
            //console.log(error);
          })
    })
    // this.closebubblecross = false;
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    // this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }


  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id"),
      email: await this.storage.get("email"),
      rememberMe: await this.storage.get('rememberMe'),
      trailDaysLeft: await this.storage.get("free_trail_days_left"),
      freeTrialMode: await this.storage.get("free_trial_mode"),
      showDialog: await this.storage.get("showDialog"),
      roleid: await this.storage.get("role_id"),
    }
    return data;
  }

  // Method to check if a route matches the provided route
  isCurrentRoute(route: string): boolean {
    return this.router.url === route;
  }

  getRoute() {
    if (this.isCurrentRoute('/vendor/marketplace') || this.isCurrentRoute(`/vendor/marketplace/details/${this.routeId}`) || this.isCurrentRoute('/vendor/marketplace/cart')) {
      return "marketplace-header";
    }
  }

  getCartRoute() {
    if (this.isCurrentRoute('/vendor/marketplace') || this.isCurrentRoute(`/vendor/marketplace/details/${this.routeId}`) || this.isCurrentRoute('/vendor/marketplace/cart')) {
      return "settings-section";
    }
  }

  hasRoute(route: string) {
    return this.isCurrentRoute(route);
  }

  onDropdownItemSelected(id, name, category, $event) {
    this.searchService.sendSelectedCategory(id, name, category, $event);
    this.defaultCategory = name;
  }

  openAboutUs() {
    const dialogRef = this.dialog.open(AboutUsPage, { restoreFocus: false });
    dialogRef.afterClosed().subscribe(() => this.menuTrigger.focus());
  }
}
